import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=d1268890&scoped=true"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=d1268890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1268890",
  null
  
)

export default component.exports